import React, { useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';

import ContentInput from './ContentInput';
import UserProfile from '../../../Component/Normal/UserProfile';
import AiAssistant from '../../../Model/Share/Normal/AiAssistant';

import LoadingAnimation from '../../../Animation/NewLoading.json';
import DefaultProfile from '../../../image/DefaultProfile.png';
import { ReactComponent as Check3Svg } from '../../../image/Check3.svg';
import { ReactComponent as MemberSvg } from '../../../image/Member.svg';
import { ReactComponent as EditSvg } from '../../../image/Edit.svg';
import { ReactComponent as MailSvg } from '../../../image/Mail.svg';

export default function SendMessageBox(props) {
  const {
    isSending,
    storeName,
    content,
    setContent,
    selectedMembers,
    onClickMemberLoading,
    onClickSelectedDelete,
    onClickAllDelete,
    onClickMemberInfo,
    decideMemberCount,
    decideCalcPrice,
    onClickSendMessage,
  } = props;

  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isSent, setIsSent] = useState(false);

  function handleClickSend() {
    onClickSendMessage();
    setIsSent(true);
  }

  // AI 어시스턴트 생성 컨텍스트 //
  function decideAiContext() {
    return { currentContent: content };
  }

  // AI 어시스턴트 결과 적용 //
  function onApplyAiResult(title, aiContent) {
    setContent(aiContent);
  }

  return (
    <MessageBoxWrapper>
      {
        isSending &&
        <LoadingView>
          <LottieWrapper>
            <Lottie animationData={LoadingAnimation} loop={true} />
          </LottieWrapper>
        </LoadingView>
      }
      <MessageBox>
        <WriteCommponentWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.titleLabel')}</Text>
          <TitleInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{storeName}</Text>
          </TitleInputView>
        </WriteCommponentWrapper>
        <WriteCommponentWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.contentLabel')}</Text>
          <ContentInput
            value={content}
            setValue={setContent}
            placeholder={t('messageSend.contentPlaceholder')} />
        </WriteCommponentWrapper>
        <DivisionLine />
        <AiAssistantWrapper>
          <AiAssistant
            type='message'
            context={decideAiContext}
            onApply={onApplyAiResult} />
        </AiAssistantWrapper>
      </MessageBox>
      <MemberSelectBoxWrapper>
        <MemberFindButton isSelected={selectedMembers.length !== 0} onClick={onClickMemberLoading}>
          {selectedMembers.length !== 0 ? <EditIcon /> : <MemberIcon />}
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} hover='pointer'>{selectedMembers.length !== 0 ? t('messageSend.editMemberList') : t('messageSend.loadFromMemberList')}</Text>
        </MemberFindButton>
        {
          selectedMembers.length === 0 ?
            <NoneSelectedBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('messageSend.noSelectedMembers')}</Text>
            </NoneSelectedBox>
            :
            <MemberSelectBox>
              <MemberSelectBoxButtonWrapper>
                <DeleteButton onClick={onClickSelectedDelete}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.deleteSelected')}</Text>
                </DeleteButton>
                <DeleteButton onClick={onClickAllDelete}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.deleteAll')}</Text>
                </DeleteButton>
              </MemberSelectBoxButtonWrapper>
              <SelectedMemberBox>
                <SelectedMemberInfoWrapper height={37 * selectedMembers.length}>
                  {
                    selectedMembers.map((data, index) => (
                      <SelectedMemberInfo key={'FinalSelectedMember-' + index}>
                        <SelectedMemberInfoLeftWrapper>
                          <ProfileWrapper isFirst={index === 0} isLast={selectedMembers.length - 1 === index}>
                            <UserProfile profile={data.profile} defaultProfile={DefaultProfile} />
                          </ProfileWrapper>
                          <SelectedMemberTextWrapper marginLeft={10} width={120}>
                            <Text style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{data.name}</Text>
                          </SelectedMemberTextWrapper>
                          <SelectedMemberTextWrapper marginLeft={4} width={120}>
                            <Text style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('messageSend.noPhone')}</Text>
                          </SelectedMemberTextWrapper>
                        </SelectedMemberInfoLeftWrapper>
                        <MemberCheckBoxWrapper>
                          <MemberCheckBox isClicked={data.isClicked} onClick={() => onClickMemberInfo(data)}>
                            {
                              data.isClicked &&
                              <CheckIcon />
                            }
                          </MemberCheckBox>
                        </MemberCheckBoxWrapper>
                      </SelectedMemberInfo>
                    ))
                  }
                </SelectedMemberInfoWrapper>
              </SelectedMemberBox>
              {/* <SettingTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{decideMemberCount()}</Text>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{decideCalcPrice()}</Text>
              </SettingTextWrapper> */}
              <SendMessageButton isSent={isSent} onClick={handleClickSend}>
                <MailIcon isSent={isSent} />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isSent ? theme.text : theme.background} hover='pointer'>{isSent ? t('messageSend.sendMessageDone') : t('messageSend.sendMessage')}</Text>
              </SendMessageButton>
            </MemberSelectBox>
        }
      </MemberSelectBoxWrapper>
    </MessageBoxWrapper>
  )
}

const MessageBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 40px;

  width: 1035px;
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 10px 0px;
  margin-top: 20px;

  width: 590px;

  gap: 20px;
`;

const DivisionLine = styled.div`
  align-self: stretch;

  margin: 10px 20px;

  height: 1px;

  background-color: ${props => props.theme.line};
`;

const AiAssistantWrapper = styled.div`
  padding: 0 20px;

  box-sizing: border-box;
  width: 100%;
`;

const LoadingView = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  margin-top: 28px;

  justify-content: center;
  align-items: center;

  width: 627px;
  height: 526px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const WriteCommponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0 20px;

  box-sizing: border-box;
  width: 100%;

  gap: 5px;
`;

const TitleInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  overflow: hidden;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
`;

const SettingTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0px 10px;
  margin-top: 16px;

  gap: 4px;

  width: calc(100% - 20px);
`;

const MemberSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 402px;
`;

const MemberFindButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;

  box-sizing: border-box;
  width: 100%;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.isSelected ? props.theme.primaryAlpha50 : props.theme.primary};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const MemberIcon = styled(MemberSvg)`
  width: 18px;
  height: 18px;

  flex-shrink: 0;

  color: ${props => props.theme.background};

  transition: color 0.3s ease-in-out;
`;

const EditIcon = styled(EditSvg)`
  width: 18px;
  height: 18px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.background};
  }

  transition: all 0.3s ease-in-out;
`;

const MemberSelectBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const MemberSelectBoxButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const NoneSelectedBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  box-sizing: border-box;
  width: 100%;
  height: 113px;

  border-radius: 5px;

  background-image: ${props => {
    const color = encodeURIComponent(props.theme.line);
    return `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${color}' stroke-width='2.5' stroke-dasharray='9%2c 11' rx='5' ry='5'/%3e%3c/svg%3e")`;
  }};
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 15px;
  height: 31px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SelectedMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;
  height: 222px;

  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
    border: 2px solid transparent;
    height: 25px;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
    border: 4px solid transparent;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

const SelectedMemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 10px;

  width: 390px;

  background-color: ${props => props.theme.subBackground};
`;

const SelectedMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 37px;
`;

const SelectedMemberInfoLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center
`;

const ProfileWrapper = styled.div`
  width: 37px;
  height: 37px;

  overflow: hidden;

  img {
    object-fit: cover;
    object-position: center;
  }
`;

const SelectedMemberTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: ${props => props.marginLeft}px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const MemberCheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 37px;
  height: 37px;
`;

const MemberCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 20px;
  height: 20px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 2px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const SendMessageButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;

  gap: 6px;

  border-radius: 5px;
  background-color: ${props => props.isSent ? props.theme.subBackground : props.theme.primary};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MailIcon = styled(MailSvg)`
  margin-top: 2px;

  width: 18px;
  height: 18px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.isSent ? props.theme.text : props.theme.background};
  }
`;

const CheckIcon = styled(Check3Svg)`
  width: 10px;
  height: 8px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.background};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;
